module.exports = __webpack_public_path__ + "img/ringsize.0753742.webp";